module.exports = {"451028100":"同乐镇","451028101":"甘田镇","451028102":"新化镇","451028103":"花坪镇","451028201":"逻沙乡","451028203":"逻西乡","451028204":"幼平乡","451028205":"雅长乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451028.json
// module id = 2148
// module chunks = 0